/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';
import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");
import { ServiceConfig } from "../core/core.constants";

export function initialize(module: ng.IModule) {
    module.service(SummationGroupDataService.Id, SummationGroupDataService);

    SummationGroupDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}
@Injectable()
export class SummationGroupDataService extends base.BaseDataService<Nema.Crew.Model.ActivityTypeSummationGroup> {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "summationGroupDataService";

    public get EntityName(): string {
        return "ActivityTypeSummationGroup";
    }

    public get EntitiesName(): string {
        return "ActivityTypeSummationGroups";
    }

    public deleteRelatedEntities(entity: Nema.Crew.Model.ActivityTypeSummationGroup): Promise<void> {
        entity.ActivityTypeSummationGroupMapping.forEach(step => (<breeze.Entity><any>step).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public newSummationGroupMapping(defaultActivityTypeId: number): Nema.Crew.Model.ActivityTypeSummationGroupMapping {
        return <Nema.Crew.Model.ActivityTypeSummationGroupMapping><any>this.entityManager.createEntity('ActivityTypeSummationGroupMapping', {
            Active: true,
            ActivityType: null,
            ActivityTypeSummationGroup: null,
            ActivityTypeSummationGroupId: -1,
            ActivityTypeId: defaultActivityTypeId,
            Name: "",
            SortTag: "",
            TimeNorm: 1,
            UseTypeNorm: true,
            CreatedDate: new Date(),
            CreatedBy: ServiceConfig.loggedInUser
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/summationgroups.dataservice.ts